import { useEffect, useState, useCallback } from "react";

const KEY = "pcg2025_favorites_v1";

export function useFavorites() {
  const [favs, setFavs] = useState(() => {
    try {
      const v = localStorage.getItem(KEY);
      return v ? JSON.parse(v) : [];
    } catch (e) {
      console.warn("useFavorites: corrupt localStorage, using []", e);
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(favs));
    } catch (e) {
      console.warn("useFavorites: failed to persist favs", e);
    }
  }, [favs]);

  const toggle = useCallback((num) => {
    setFavs((cur) => (cur.includes(num) ? cur.filter((n) => n !== num) : [...cur, num]));
  }, []);

  const isFav = useCallback((num) => favs.includes(num), [favs]);

  const clear = useCallback(() => setFavs([]), []);

  return { favs, toggle, isFav, clear };
}
